import { APP_CONFIG } from '@1bill-app/constants';
import { environment } from '@1bill-app/env';
import { objDeepEquals } from '@1bill-app/helpers/object.helper';
import { SettingsQuery } from '@1bill-app/services/settings/settings.query';
import { SettingsService } from '@1bill-app/services/settings/settings.service';
import {
  createInitialState,
  Settings,
  SettingsOptions,
} from '@1bill-app/services/settings/settings.store';
import { Component, OnInit } from '@angular/core';
import { LoadingController, ToastController } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-reminders',
  templateUrl: './reminders.page.html',
  styleUrls: ['./reminders.page.scss'],
})
export class RemindersPage implements OnInit {
  isFormUntouched: boolean = true;
  dueDay: boolean;
  oneDay: boolean;
  twoDays: boolean;
  sevenDays: boolean;
  initialFormValues: any;
  currentValues: any;
  subs = new SubSink();
  saving: boolean = false;
  loading: any;
  constructor(
    private _settings: SettingsService,
    public query: SettingsQuery,
    private toastCtrl: ToastController,
    private loadingController: LoadingController,
    private logger: NGXLogger,
  ) {
    // this.dueDay = true;
    // this.sevenDays = true;
  }

  async ionViewWillEnter() {}

  async ionViewWillLeave() {
    if (this.loading) {
      this.loading.dismiss();
    }
  }

  ngOnInit() {
    this.fetchData();
    this.query.select().subscribe({
      next: (settingsData) => {
        // this.logger.log('query fetch settings data: ' + JSON.stringify(settingsData))
        this.initialFormValues = {
          dueDay: false,
          oneDay: false,
          twoDays: false,
          sevenDays: false,
        };

        if (settingsData.reminderDays && settingsData.reminderDays.indexOf(0) > -1) {
          this.initialFormValues.dueDay = true;
          this.dueDay = true;
        }

        if (settingsData.reminderDays && settingsData.reminderDays.indexOf(1) > -1) {
          this.initialFormValues.oneDay = true;
          this.oneDay = true;
        }

        if (settingsData.reminderDays && settingsData.reminderDays.indexOf(2) > -1) {
          this.initialFormValues.twoDays = true;
          this.twoDays = true;
        }

        if (settingsData.reminderDays && settingsData.reminderDays.indexOf(7) > -1) {
          this.initialFormValues.sevenDays = true;
          this.sevenDays = true;
        }
      },
      error: (err) => {
        this.logger.error('unable to retrieve user setting from data store', err);
      },
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  toggleUpdate() {
    this.logger.debug({
      dueDay: this.dueDay,
      oneDay: this.oneDay,
      twoDays: this.twoDays,
      sevenDays: this.sevenDays,
    });
    this.currentValues = {
      dueDay: this.dueDay ? this.dueDay : false,
      oneDay: this.oneDay ? this.oneDay : false,
      twoDays: this.twoDays ? this.twoDays : false,
      sevenDays: this.sevenDays ? this.sevenDays : false,
    };

    // this.logger.log('form change results:', result);
    if (objDeepEquals(this.initialFormValues, this.currentValues)) {
      this.isFormUntouched = true;
    } else {
      // this.logger.log('value changed');
      this.isFormUntouched = false;
    }
  }

  async fetchData() {
    this.loading = await this.loadingController.create({
      message: 'Loading settings data...',
    });
    this.loading.present();
    this.subs.sink = this._settings.fetch().subscribe({
      next: (r) => {
        // this.logger.log('user settings data fetched:', JSON.stringify(r));
        this.isFormUntouched = true;
        this.loading.dismiss();
      },
      error: (e) => {
        this.logger.error('unable to fetch user settings data', e);
        this.loading.dismiss();
      },
    });
  }

  async onSave() {
    this.loading = await this.loadingController.create({
      message: 'Saving reminder settings...',
    });
    this.loading.present();
    try {
      // STAGE: ready for save
      if (!environment.production) {
        this.logger.debug(this.currentValues);
      }
      this.saving = true;
      let data: Settings = createInitialState();
      data.reminderDays = [];
      if (this.currentValues.dueDay) {
        data.reminderDays.push(0);
      }
      if (this.currentValues.oneDay) {
        data.reminderDays.push(1);
      }
      if (this.currentValues.twoDays) {
        data.reminderDays.push(2);
      }
      if (this.currentValues.sevenDays) {
        data.reminderDays.push(7);
      }

      const payload: SettingsOptions = { option: 'REMINDER', settingsData: data };
      await this._settings.saveSettingDetails(payload).toPromise();
      this.loading.dismiss();
      this.showSuccess('Settings saved successfully.');
      this.fetchData();
      this.isFormUntouched = true;
    } catch (err) {
      if (!environment.production) {
        console.error(err);
      }
      this.loading.dismiss();
      // send error log to server
      this.logger.error('onSave reminders',err);
      // display error toast
      this.showError('Error occurred while saving settings data!!');
    }
    this.saving = false;
  }

  async showSuccess(message: string) {
    const toast = await this.toastCtrl.create({
      message,
      duration: APP_CONFIG.TOAST_SUCCESS_DURATION,
      cssClass: ['toast-error'],
    });
    await toast.present();
  }

  async showError(err: any, danger = false) {
    if (!err) {
      return;
    }
    const message = err.statusText || err.message || err;
    const toast = await this.toastCtrl.create({
      message,
      duration: APP_CONFIG.TOAST_ERROR_DURATION,
      color: danger ? 'danger' : 'warning',
      // cssClass: ['toast-error']
    });
    await toast.present();
  }
}
